module.exports = __webpack_public_path__ + "img/44.75bbea39.png";